import { CheckoutExtensionUI, CheckoutUpsellExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';

export interface DropdownOption {
  label: string;
  value: string;
}

export const BORDER_OPTIONS: DropdownOption[] = [
  { label: 'None', value: CheckoutExtensionUI.BorderType.NONE },
  { label: 'Base', value: CheckoutExtensionUI.BorderType.BASE },
  { label: 'Dotted', value: CheckoutExtensionUI.BorderType.DOTTED },
];

export const BORDER_WIDTH_OPTIONS: DropdownOption[] = [
  { label: 'Base', value: CheckoutExtensionUI.BorderWidth.BASE },
  { label: 'Medium', value: CheckoutExtensionUI.BorderWidth.MEDIUM },
];

export const CORNER_RADIUS_OPTIONS: DropdownOption[] = [
  { label: 'None', value: CheckoutExtensionUI.CornerRadius.NONE },
  { label: 'Small', value: CheckoutExtensionUI.CornerRadius.SMALL },
  { label: 'Base', value: CheckoutExtensionUI.CornerRadius.BASE },
  { label: 'Large', value: CheckoutExtensionUI.CornerRadius.LARGE },
  { label: 'Fully Rounded', value: CheckoutExtensionUI.CornerRadius.FULLY_ROUNDED },
];

export const PADDING_OPTIONS: DropdownOption[] = [
  { label: 'None', value: CheckoutExtensionUI.Padding.NONE },
  { label: 'Small 100', value: CheckoutExtensionUI.Padding.SMALL100 },
  { label: 'Small 200', value: CheckoutExtensionUI.Padding.SMALL200 },
  { label: 'Small 300', value: CheckoutExtensionUI.Padding.SMALL300 },
  { label: 'Small 400', value: CheckoutExtensionUI.Padding.SMALL400 },
  { label: 'Small 500', value: CheckoutExtensionUI.Padding.SMALL500 },
  { label: 'Base', value: CheckoutExtensionUI.Padding.BASE },
  { label: 'Large 100', value: CheckoutExtensionUI.Padding.LARGE100 },
  { label: 'Large 200', value: CheckoutExtensionUI.Padding.LARGE200 },
  { label: 'Large 300', value: CheckoutExtensionUI.Padding.LARGE300 },
  { label: 'Large 400', value: CheckoutExtensionUI.Padding.LARGE400 },
  { label: 'Large 500', value: CheckoutExtensionUI.Padding.LARGE500 },
];

export const BUTTON_APPEARANCE_OPTIONS: DropdownOption[] = [
  { label: 'Base', value: CheckoutUpsellExtension.ButtonAppearance.BASE },
  { label: 'Accent', value: CheckoutUpsellExtension.ButtonAppearance.ACCENT },
  { label: 'Decorative', value: CheckoutUpsellExtension.ButtonAppearance.DECORATIVE },
  { label: 'Interactive', value: CheckoutUpsellExtension.ButtonAppearance.INTERACTIVE },
  { label: 'Subdued', value: CheckoutUpsellExtension.ButtonAppearance.SUBDUED },
  { label: 'Info', value: CheckoutUpsellExtension.ButtonAppearance.INFO },
  { label: 'Success', value: CheckoutUpsellExtension.ButtonAppearance.SUCCESS },
  { label: 'Warning', value: CheckoutUpsellExtension.ButtonAppearance.WARNING },
  { label: 'Critical', value: CheckoutUpsellExtension.ButtonAppearance.CRITICAL },
  { label: 'Monochrome', value: CheckoutUpsellExtension.ButtonAppearance.MONOCHROME },
];
